import { render, staticRenderFns } from "./GuestRoom.vue?vue&type=template&id=a99b7048&scoped=true"
import script from "./GuestRoom.vue?vue&type=script&lang=js"
export * from "./GuestRoom.vue?vue&type=script&lang=js"
import style0 from "./GuestRoom.vue?vue&type=style&index=0&id=a99b7048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b7048",
  null
  
)

export default component.exports